"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHtml = toHtml;
const Format_1 = require("../Format");
const Style_1 = require("../Style");
function toHtml(lines) {
    let html = [];
    for (let line of lines) {
        switch (line.kind) {
            case Format_1.Format.SUBSCRIPT:
                html.push(`<sub>${line.value}</sub>`);
                break;
            case Format_1.Format.SUPERSCRIPT:
                html.push(`<sup>${line.value}</sup>`);
                break;
            case Format_1.Format.SUPERIMPOSE:
                html.push(`<span style="${Style_1.Style.SUPERIMPOSE}">`, `<sup style="${Style_1.Style.SUPERIMPOSE_SUP_SUB}">${line.over}</sup>`, `<sub style="${Style_1.Style.SUPERIMPOSE_SUP_SUB}">${line.under}</sub>`, '</span>');
                break;
            default:
                html.push(line.value);
        }
    }
    return html.join('');
}
//# sourceMappingURL=toHtml.js.map